export const STANDARD_LOGIC = 0;
export const REVERSED_LOGIC = 1;
